(() => {
  if (window.onlyGamesSaleLanding) return;
  window.onlyGamesSaleLanding = true;
  const instances = new Map();
  function init(scope) {
    scope.querySelectorAll('[data-ogs-sale]').forEach(root => {
      if (instances.has(root)) return;
      const cleanups = [];
      const listen = (el, name, fn) => {
        el.addEventListener(name, fn);
        cleanups.push(() => el.removeEventListener(name, fn));
      };
      const end = Date.parse(root.dataset.ends);
      const countdown = root.querySelector('[data-ogs-countdown]');
      const tick = () => {
        if (!Number.isFinite(end)) {
          if (countdown) countdown.parentElement.hidden = true;
          return;
        }
        if (Date.now() >= end) {
          root.hidden = true;
          cleanups.forEach(fn => fn());
          instances.delete(root);
          return;
        }
        const seconds = Math.floor((end - Date.now()) / 1000);
        const pad = n => String(n).padStart(2, '0');
        if (countdown) countdown.textContent = `${Math.floor(seconds / 86400)}d ${pad(Math.floor(seconds / 3600) % 24)}:${pad(Math.floor(seconds / 60) % 60)}:${pad(seconds % 60)}`;
      };
      const clock = setInterval(tick, 1000);
      cleanups.push(() => clearInterval(clock));
      const carousel = root.querySelector('[data-ogs-carousel]');
      if (carousel) {
        const track = carousel.querySelector('.ogs-car-track');
        const section = carousel.closest('section');
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let touching = false;
        const go = direction => {
          const card = track.querySelector('.ogs-card');
          if (!card) return;
          const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
          const max = Math.max(0, track.scrollWidth - track.clientWidth);
          const left = direction > 0 && track.scrollLeft >= max - 2 ? 0
            : direction < 0 && track.scrollLeft <= 2 ? max : track.scrollLeft + direction * step;
          track.scrollTo({ left, behavior: motion.matches ? 'auto' : 'smooth' });
        };
        listen(section.querySelector('[data-ogs-prev]'), 'click', () => go(-1));
        listen(section.querySelector('[data-ogs-next]'), 'click', () => go(1));
        listen(track, 'touchstart', () => { touching = true; });
        listen(track, 'touchend', () => { touching = false; });
        listen(track, 'touchcancel', () => { touching = false; });
        const interval = Number(carousel.dataset.interval);
        if (interval > 0) {
          const timer = setInterval(() => {
            if (!document.hidden && !motion.matches && !touching && !section.matches(':hover') && !section.contains(document.activeElement)) go(1);
          }, interval * 1000);
          cleanups.push(() => clearInterval(timer));
        }
      }
      instances.set(root, () => cleanups.forEach(fn => fn()));
      tick();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((cleanup, root) => {
      if (event.target.contains(root)) { cleanup(); instances.delete(root); }
    });
  });
})();
